// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navigation from './components/Navigation';
import PrivateRoute from './components/PrivateRoute';
import InstallBanner from './components/InstallBanner';

import Landing      from './pages/Landing';
import Inscription, { Connexion } from './pages/Inscription';
import Carte        from './pages/Carte';
import Messages     from './pages/Messages';
import Moment       from './pages/Moment';
import Profil       from './pages/Profil';
import Onboarding from './pages/Onboarding';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Navigation />
        <InstallBanner />
        <Routes>
          {/* Public */}
          <Route path="/"            element={<Landing />} />
          <Route path="/inscription" element={<Inscription />} />
          <Route path="/connexion"   element={<Connexion />} />
          <Route path="/onboarding" element={<Onboarding />} />

          {/* Privé – nécessite d'être connecté */}
          <Route path="/carte"           element={<PrivateRoute><Carte /></PrivateRoute>} />
          <Route path="/messages"        element={<PrivateRoute><Messages /></PrivateRoute>} />
          <Route path="/messages/:userId" element={<PrivateRoute><Messages /></PrivateRoute>} />
          <Route path="/moment"          element={<PrivateRoute><Moment /></PrivateRoute>} />
          <Route path="/profil"          element={<PrivateRoute><Profil /></PrivateRoute>} />
          <Route path="/profil/:id"      element={<PrivateRoute><Profil /></PrivateRoute>} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
